/* find reference nets by signal nets status */
export const FIND_REF_NET_RUNNING = 0, FIND_REF_NET_SUCCESS = 1, FIND_REF_NET_FAILED = 2;